import React from 'react';
import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import { IGlobalStorage } from '../../../../../../infrastructure/global-storage';
import { IErrorParsing } from '../../../../../../infrastructure/error-parsing';
import { IAlertsService } from '../../../../../../infrastructure/alerts';
import { IArtifactsDAO } from '../../../../../../api/artifacts.dao';
import { alertServerError } from '../../../../../global/modal/alerts-host/alert-templates';
import { calcByteCodeSize } from '../../../../../../infrastructure/utils/common.utils';
import { LONG_PLAIN_TEXT_LENGTH } from '../../../../../../constants/common.constants';
import { FormattedMessage } from 'react-intl';

export class ArtifactNotesViewModel {
    @mobx.observable
    public note: string;
    public permissionToEdit: boolean;
    constructor(
        public readonly assetMetadataId: number,
        note: string,
        public closeArtifactNotesPopup: () => void,
        public onUpdateArtifactNotes: (assetMetadataId: number, note: string) => void,
        @IoC.Inject private readonly errorParsingService: IErrorParsing = IoC.Container.get(IErrorParsing),
        @IoC.Inject private readonly alertsService: IAlertsService = IoC.Container.get(IAlertsService),
        @IoC.Inject private readonly artifactsDAO: IArtifactsDAO = IoC.Container.get(IArtifactsDAO),
        @IoC.Inject private readonly globalStorage: IGlobalStorage = IoC.Container.get(IGlobalStorage)
    ) {
        this.note = note || '';
        this.permissionToEdit = hasPermission(Permission.EDIT_ARTIFACT);
    }

    public static handleApiException(e: Error, title: string = 'Error'): void {
        if (e) alertServerError(title, IoC.Container.get(IErrorParsing).extractMessage(e));
    }

    public getNotesError = (): JSX.Element | null => {
        return calcByteCodeSize(this.note) > LONG_PLAIN_TEXT_LENGTH
            ? <FormattedMessage
                id='oe.artifact.notesTooLong'
                description='Warning message'
                defaultMessage='Notes is too long - max lenght is 4096 characters'
            />
            : null;
    };

    @mobx.action
    public setNotes = (value: string): void => {
        this.note = value;
    };

    @mobx.action
    public updateNotes = async (): Promise<void> => {
        try {
            const params = {
                eventId: this.globalStorage.getEvent().eventId,
                accountId: this.globalStorage.getEvent()?.accountId,
                assetMetadataId: this.assetMetadataId,
                note: this.note.trimEnd()
            };
            const {assetMetadataId, note} = await this.artifactsDAO.updateSingleArtifact(params);
            this.onUpdateArtifactNotes(assetMetadataId, note);
            this.closeArtifactNotesPopup();
        } catch (e) {
            ArtifactNotesViewModel.handleApiException(e);
        }
    };
}